import React from 'react';
import PropTypes from 'prop-types';
import styles from './InstallationPriceTable.module.css';
import Label from '../../EntToEndUI/Label/Label';
import Button from '../../Buttons/Button/Button';
import { useScroll } from '../../../context/ScrollContext';

const InstallationPriceTable = ({ 
  data, 
  title, 
  subtitle, 
  tableTitle, 
  buttonText, 
  buttonTitle 
}) => {
  console.log('Отрисовка таблицы цен на монтажные работы:', data);
  const { scrollTo } = useScroll();

  const handleOrderClick = () => {
    console.log('Нажата кнопка заказа в баннере');
    scrollTo('requestForm');
  };
  return (
    <section className={styles.sectionInstallationPriceTable}>
      <Label 
        topText={title}
        bottomText={subtitle}
        shift="large"
      />
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.headerName}>Наименование работ</th>
              <th className={styles.headerUnit}>Ед.изм.</th>
              <th className={styles.headerPrice}>Цена (руб)</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              item.isSection ? (
                <tr key={index} className={styles.sectionRow}>
                  <td colSpan="3" className={styles.sectionName}>{item.name}</td>
                </tr>
              ) : (
                <tr key={index}>
                  <td className={styles.name}>{item.name}</td>
                  <td className={styles.unit}>{item.unit}</td>
                  <td className={styles.price}>{item.price}</td>
                </tr>
              )
            ))}
          </tbody>
        </table>
        <div className={styles.buttonRow}>
          <p>{buttonTitle}</p>
          <Button 
            text={buttonText} 
            onClick={handleOrderClick}
            type="primary"
          />
        </div>
      </div>
    </section>
  );
};

InstallationPriceTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        isSection: PropTypes.bool,
        name: PropTypes.string.isRequired
      }),
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        unit: PropTypes.string.isRequired,
        price: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number
        ]).isRequired
      })
    ])
  ).isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  tableTitle: PropTypes.string,
  buttonText: PropTypes.string,
  buttonTitle: PropTypes.string
};

export default InstallationPriceTable; 